var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78638 5.86269C4.03584 3.66057 5.84726 2 7.99996 2C10.1527 2 11.9641 3.66057 12.2135 5.86269L12.4435 7.89233C12.5006 8.39666 12.705 8.87125 13.0296 9.25337C13.7186 10.0643 13.1594 11.3333 12.1132 11.3333H3.88672C2.8405 11.3333 2.28135 10.0643 2.97029 9.25337C3.29494 8.87125 3.49934 8.39666 3.55647 7.89233L3.78638 5.86269Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.6666C9.70888 13.4434 8.92335 14 8 14C7.07665 14 6.29112 13.4434 6 12.6666",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.64e643152804f38448a11741d8353182.svg";
export { ForwardRef as ReactComponent };